/* tslint:disable */
/* eslint-disable */
/**
 * TOM STORAGE SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateYardPositionDto } from '../model';
// @ts-ignore
import type { CreateYardReservationDto } from '../model';
// @ts-ignore
import type { YardBlockSlotLocationDto } from '../model';
// @ts-ignore
import type { YardBlockSlotOccupancyDto } from '../model';
/**
 * YardBlockSlotOccupanciesApi - axios parameter creator
 */
export const YardBlockSlotOccupanciesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateYardReservationDto} [createYardReservationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockSlotOccupanciesCreateReservation: async (createYardReservationDto?: CreateYardReservationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlockSlotOccupancies/CreateReservation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createYardReservationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [turnoverId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockSlotOccupanciesGetTargetSlot: async (turnoverId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlockSlotOccupancies/GetTargetSlot`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (turnoverId !== undefined) {
                localVarQueryParameter['turnoverId'] = turnoverId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateYardPositionDto} [createYardPositionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockSlotOccupanciesUpdateContainerPosition: async (createYardPositionDto?: CreateYardPositionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlockSlotOccupancies/UpdateContainerPosition`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createYardPositionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateYardPositionDto} [createYardPositionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockSlotOccupanciesValidateDGStackingAndSegregationRulesViolation: async (createYardPositionDto?: CreateYardPositionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlockSlotOccupancies/ValidateDGStackingAndSegregationRulesViolation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createYardPositionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * YardBlockSlotOccupanciesApi - functional programming interface
 */
export const YardBlockSlotOccupanciesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = YardBlockSlotOccupanciesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateYardReservationDto} [createYardReservationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlockSlotOccupanciesCreateReservation(createYardReservationDto?: CreateYardReservationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<YardBlockSlotOccupancyDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlockSlotOccupanciesCreateReservation(createYardReservationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlockSlotOccupanciesApi.yardBlockSlotOccupanciesCreateReservation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [turnoverId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlockSlotOccupanciesGetTargetSlot(turnoverId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YardBlockSlotLocationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlockSlotOccupanciesGetTargetSlot(turnoverId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlockSlotOccupanciesApi.yardBlockSlotOccupanciesGetTargetSlot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateYardPositionDto} [createYardPositionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlockSlotOccupanciesUpdateContainerPosition(createYardPositionDto?: CreateYardPositionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<YardBlockSlotOccupancyDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlockSlotOccupanciesUpdateContainerPosition(createYardPositionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlockSlotOccupanciesApi.yardBlockSlotOccupanciesUpdateContainerPosition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateYardPositionDto} [createYardPositionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlockSlotOccupanciesValidateDGStackingAndSegregationRulesViolation(createYardPositionDto?: CreateYardPositionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlockSlotOccupanciesValidateDGStackingAndSegregationRulesViolation(createYardPositionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlockSlotOccupanciesApi.yardBlockSlotOccupanciesValidateDGStackingAndSegregationRulesViolation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * YardBlockSlotOccupanciesApi - factory interface
 */
export const YardBlockSlotOccupanciesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = YardBlockSlotOccupanciesApiFp(configuration)
    return {
        /**
         * 
         * @param {YardBlockSlotOccupanciesApiYardBlockSlotOccupanciesCreateReservationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockSlotOccupanciesCreateReservation(requestParameters: YardBlockSlotOccupanciesApiYardBlockSlotOccupanciesCreateReservationRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<YardBlockSlotOccupancyDto>> {
            return localVarFp.yardBlockSlotOccupanciesCreateReservation(requestParameters.createYardReservationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {YardBlockSlotOccupanciesApiYardBlockSlotOccupanciesGetTargetSlotRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockSlotOccupanciesGetTargetSlot(requestParameters: YardBlockSlotOccupanciesApiYardBlockSlotOccupanciesGetTargetSlotRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<YardBlockSlotLocationDto> {
            return localVarFp.yardBlockSlotOccupanciesGetTargetSlot(requestParameters.turnoverId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {YardBlockSlotOccupanciesApiYardBlockSlotOccupanciesUpdateContainerPositionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockSlotOccupanciesUpdateContainerPosition(requestParameters: YardBlockSlotOccupanciesApiYardBlockSlotOccupanciesUpdateContainerPositionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<YardBlockSlotOccupancyDto>> {
            return localVarFp.yardBlockSlotOccupanciesUpdateContainerPosition(requestParameters.createYardPositionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {YardBlockSlotOccupanciesApiYardBlockSlotOccupanciesValidateDGStackingAndSegregationRulesViolationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockSlotOccupanciesValidateDGStackingAndSegregationRulesViolation(requestParameters: YardBlockSlotOccupanciesApiYardBlockSlotOccupanciesValidateDGStackingAndSegregationRulesViolationRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.yardBlockSlotOccupanciesValidateDGStackingAndSegregationRulesViolation(requestParameters.createYardPositionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for yardBlockSlotOccupanciesCreateReservation operation in YardBlockSlotOccupanciesApi.
 */
export interface YardBlockSlotOccupanciesApiYardBlockSlotOccupanciesCreateReservationRequest {
    readonly createYardReservationDto?: CreateYardReservationDto
}

/**
 * Request parameters for yardBlockSlotOccupanciesGetTargetSlot operation in YardBlockSlotOccupanciesApi.
 */
export interface YardBlockSlotOccupanciesApiYardBlockSlotOccupanciesGetTargetSlotRequest {
    readonly turnoverId?: string
}

/**
 * Request parameters for yardBlockSlotOccupanciesUpdateContainerPosition operation in YardBlockSlotOccupanciesApi.
 */
export interface YardBlockSlotOccupanciesApiYardBlockSlotOccupanciesUpdateContainerPositionRequest {
    readonly createYardPositionDto?: CreateYardPositionDto
}

/**
 * Request parameters for yardBlockSlotOccupanciesValidateDGStackingAndSegregationRulesViolation operation in YardBlockSlotOccupanciesApi.
 */
export interface YardBlockSlotOccupanciesApiYardBlockSlotOccupanciesValidateDGStackingAndSegregationRulesViolationRequest {
    readonly createYardPositionDto?: CreateYardPositionDto
}

/**
 * YardBlockSlotOccupanciesApi - object-oriented interface
 */
export class YardBlockSlotOccupanciesApi extends BaseAPI {
    /**
     * 
     * @param {YardBlockSlotOccupanciesApiYardBlockSlotOccupanciesCreateReservationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlockSlotOccupanciesCreateReservation(requestParameters: YardBlockSlotOccupanciesApiYardBlockSlotOccupanciesCreateReservationRequest = {}, options?: RawAxiosRequestConfig) {
        return YardBlockSlotOccupanciesApiFp(this.configuration).yardBlockSlotOccupanciesCreateReservation(requestParameters.createYardReservationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {YardBlockSlotOccupanciesApiYardBlockSlotOccupanciesGetTargetSlotRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlockSlotOccupanciesGetTargetSlot(requestParameters: YardBlockSlotOccupanciesApiYardBlockSlotOccupanciesGetTargetSlotRequest = {}, options?: RawAxiosRequestConfig) {
        return YardBlockSlotOccupanciesApiFp(this.configuration).yardBlockSlotOccupanciesGetTargetSlot(requestParameters.turnoverId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {YardBlockSlotOccupanciesApiYardBlockSlotOccupanciesUpdateContainerPositionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlockSlotOccupanciesUpdateContainerPosition(requestParameters: YardBlockSlotOccupanciesApiYardBlockSlotOccupanciesUpdateContainerPositionRequest = {}, options?: RawAxiosRequestConfig) {
        return YardBlockSlotOccupanciesApiFp(this.configuration).yardBlockSlotOccupanciesUpdateContainerPosition(requestParameters.createYardPositionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {YardBlockSlotOccupanciesApiYardBlockSlotOccupanciesValidateDGStackingAndSegregationRulesViolationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlockSlotOccupanciesValidateDGStackingAndSegregationRulesViolation(requestParameters: YardBlockSlotOccupanciesApiYardBlockSlotOccupanciesValidateDGStackingAndSegregationRulesViolationRequest = {}, options?: RawAxiosRequestConfig) {
        return YardBlockSlotOccupanciesApiFp(this.configuration).yardBlockSlotOccupanciesValidateDGStackingAndSegregationRulesViolation(requestParameters.createYardPositionDto, options).then((request) => request(this.axios, this.basePath));
    }
}

